class FeaturesSection extends HTMLElement {
  constructor() {
    super();

    this.sectionFeatures = this.querySelectorAll('.section--features');
    this.btns = this.querySelectorAll('.section--features .section--features__navigation > button');
    this.init();
  }

  init() {
    this.hideFeaturesSection();
    this.sectionFeatures.forEach(block => {
      block.querySelectorAll('.section--features__navigation > button').forEach((btn, i) => {
        const span = document.createElement('span');
        span.classList.add('divider');
        span.innerText = '/';

        if (i != 0) {
          btn.parentNode.insertBefore(span, btn);
        }
      })
    })

    this.btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        this.onNavClick(btn);
      })
    })
  }

  hideFeaturesSection() {
    this.sectionFeatures.forEach((block, i) => {
      if (i != 0) {
        block.classList.add('d-none');
      }
    })
  }

  onNavClick(btn) {
    const block = this.getElementsByClassName(btn.dataset.block);
    this.sectionFeatures.forEach((block) => {
      block.classList.add('d-none');
    })
    if (block) {
      if (typeof block == 'object') {
        block[0].classList.remove('d-none');
        block[0].classList.add('d-block');
      } else {
        block.classList.remove('d-none');
        block.classList.add('d-block');
      }
    }
  }
}

customElements.define('features-section', FeaturesSection);